export default __webpack_public_path__ + "static/media/group-pictures.be74a956.svg";